import React from 'react';
import './Projects.css';

const Projects = () => {
  const residentialProjects = [
    {
      id: 1,
      title: 'Hệ thống 10kWp - Hà Nội',
      location: 'Quận Tây Hồ, Hà Nội',
      capacity: '10 kWp',
      saving: '90%',
      image: 'https://images.unsplash.com/photo-1558449028-b53a39d100fc?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 2,
      title: 'Hệ thống 15kWp - TP.HCM',
      location: 'Quận 7, TP.HCM',
      capacity: '15 kWp',
      saving: '85%',
      image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 3,
      title: 'Hệ thống 8kWp - Đà Nẵng',
      location: 'Quận Hải Châu, Đà Nẵng',
      capacity: '8 kWp',
      saving: '88%',
      image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  const commercialProjects = [
    {
      id: 1,
      title: 'Nhà máy ABC - Bình Dương',
      location: 'KCN Vsip, Bình Dương',
      capacity: '500 kWp',
      saving: '70%',
      image: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 2,
      title: 'Công ty XYZ - Đồng Nai',
      location: 'KCN Amata, Đồng Nai',
      capacity: '1.2 MWp',
      saving: '75%',
      image: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    },
    {
      id: 3,
      title: 'Nhà xưởng DEF - Long An',
      location: 'KCN Tân Kim, Long An',
      capacity: '800 kWp',
      saving: '72%',
      image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  return (
    <section id="projects" className="projects-section">
      {/* Residential Projects */}
      <div className="projects-residential">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5" data-aos="fade-right">
              <div className="projects-info">
                <span className="section-tag">DỰ ÁN DÂN DỤNG</span>
                <h2 className="projects-title">
                  Dự án điện mặt trời cho hộ gia đình
                </h2>
                <p className="projects-description">
                  Đối với các hộ gia đình, Gnine Solar đã phục vụ hơn <strong>2689+ khách hàng</strong> ở 
                  hơn 50 tỉnh thành trên cả nước. Vì hiểu rằng mỗi gia đình đều có những nhu cầu riêng biệt, 
                  chúng tôi luôn mang đến các giải pháp đầu tư điện mặt trời linh hoạt và tối ưu.
                </p>
                <div className="projects-stats">
                  <div className="stat-box">
                    <h3>2689+</h3>
                    <p>Khách hàng hộ gia đình</p>
                  </div>
                  <div className="stat-box">
                    <h3>TOÀN QUỐC</h3>
                    <p>Công trình có mặt tại mọi tỉnh thành</p>
                  </div>
                </div>
                <a href="#contact" className="btn btn-primary">
                  Xem thêm dự án
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-7" data-aos="fade-left">
              <div className="projects-grid">
                {residentialProjects.map((project, index) => (
                  <div 
                    key={project.id} 
                    className="project-card"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <div className="project-image">
                      <img src={project.image} alt={project.title} />
                      <div className="project-overlay">
                        <span className="project-capacity">{project.capacity}</span>
                      </div>
                    </div>
                    <div className="project-content">
                      <h4>{project.title}</h4>
                      <p><i className="fas fa-map-marker-alt"></i> {project.location}</p>
                      <span className="project-saving">Tiết kiệm {project.saving}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Commercial Projects */}
      <div className="projects-commercial">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 order-lg-1 order-2" data-aos="fade-right">
              <div className="projects-grid">
                {commercialProjects.map((project, index) => (
                  <div 
                    key={project.id} 
                    className="project-card"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <div className="project-image">
                      <img src={project.image} alt={project.title} />
                      <div className="project-overlay">
                        <span className="project-capacity">{project.capacity}</span>
                      </div>
                    </div>
                    <div className="project-content">
                      <h4>{project.title}</h4>
                      <p><i className="fas fa-map-marker-alt"></i> {project.location}</p>
                      <span className="project-saving">Tiết kiệm {project.saving}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-5 order-lg-2 order-1" data-aos="fade-left">
              <div className="projects-info">
                <span className="section-tag">DỰ ÁN CÔNG NGHIỆP</span>
                <h2 className="projects-title">
                  Dự án điện mặt trời cho doanh nghiệp
                </h2>
                <p className="projects-description">
                  Gnine Solar là sự lựa chọn hàng đầu cho các tổ chức và doanh nghiệp muốn chuyển đổi 
                  sang năng lượng xanh. Với hơn <strong>226+ khách hàng</strong> là các tổ chức/doanh nghiệp, 
                  chúng tôi cam kết mang đến dịch vụ thi công và lắp đặt điện mặt trời trọn gói chất lượng cao.
                </p>
                <div className="projects-stats">
                  <div className="stat-box">
                    <h3>226+</h3>
                    <p>Khách hàng doanh nghiệp</p>
                  </div>
                  <div className="stat-box">
                    <h3>50MW+</h3>
                    <p>Công suất lắp đặt</p>
                  </div>
                </div>
                <a href="#contact" className="btn btn-primary">
                  Xem thêm dự án
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;